// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import type {Directions} from 'common/components/drop-menu/types';
import {userCookieUtils} from 'common/report/util/user-identity-from-cookie';
import type {DashboardSelectorController} from 'common/report/controllers/dashboard-selector-controller';
import {Translatable} from 'common/i18n';

import {DashboardSelectorEl} from './index';

export function BoardsDashboardSelector({
  recentDashboardIds,
  placeholder,
  handleDashboardSelected,
  handleMenuChanged,
  dashboardController,
  direction,
  quickCreateSaveDashboardCopy,
  open = true,
  offset,
  alignRight,
  excludedDashboards,
  currentDashboardHierarchyTreeHeight,
  descendantDashboardIds,
  showProjectSelector,
  hideDashboardList,
  showMoveOutButton,
  enableNestedDashboardsRestrictions,
  detailedExplainCopy,
}: {
  recentDashboardIds: number[];
  placeholder: string;
  handleDashboardSelected: (ev: CustomEvent) => void;
  handleMenuChanged?: (ev: CustomEvent) => void;
  dashboardController: DashboardSelectorController;
  quickCreateSaveDashboardCopy?: string;
  direction?: Directions;
  open?: boolean;
  offset?: number;
  alignRight?: boolean;
  excludedDashboards?: number[];
  currentDashboardHierarchyTreeHeight?: number;
  descendantDashboardIds?: Set<number>;
  showProjectSelector?: boolean;
  hideDashboardList?: boolean;
  showMoveOutButton?: boolean;
  enableNestedDashboardsRestrictions?: boolean;
  detailedExplainCopy?: {
    title: Translatable;
    description: Translatable;
  };
}) {
  return (
    <DashboardSelectorEl
      attrs={{
        open,
        offset,
        'compact-mode': true,
        direction,
        'disable-create-dashboard': true,
        'display-only-editable-dashboards': true,
        'hide-dashboard-list': hideDashboardList,
        'enable-nested-dashboards-restrictions': enableNestedDashboardsRestrictions,
        'quick-create': true,
        'show-creator-sublabel': true,
        'show-project-selector': showProjectSelector,
        'show-move-out-button': showMoveOutButton,
        'single-section': true,
        'user-id': userCookieUtils.getUserIdentityFromCookie()?.id,
      }}
      class={{
        'align-right': alignRight,
      }}
      on={{
        select: handleDashboardSelected,
        menuchange: handleMenuChanged,
      }}
      params={{
        quickCreateSaveDashboardCopy,
        searchPlaceholder: placeholder,
        detailedExplainCopy,
      }}
      props={{
        excludedDashboards,
        controller: dashboardController,
        initialSortedDashboardIds: recentDashboardIds,
        currentDashboardHierarchyTreeHeight,
        descendantDashboardIds,
      }}
    />
  );
}
